import React, { useContext ,useEffect} from "react";
import AdminLayout from "../../components/layout/AdminLayout";
import * as FaIcons from "react-icons/fa";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import AuthContext from "../../context/auth/authContext";

const pageLinks = [
  {
    name: "Interest Entries",
    path: "/interest-forms",
    icon: <FaIcons.FaClipboardList className="home-icon" />,
    description: "View interest entries",
  },
  {
    name: "Primary Enrollments",
    path: "/registration-forms",
    icon: <FaIcons.FaClipboardList className="home-icon" />,
    description: "View enrollment entries",
  },

  {
    name: "Secondary Enrollments",
    path: "/lelo-forms",
    icon: <FaIcons.FaClipboardList className="home-icon" />,
    description: "View secondary enrollments",
  },

  {
    name: "Scheduled Orientations",
    path: "/scheduled-orientations",
    icon: <FaIcons.FaCalendarAlt className="home-icon" />,
    description: "View scheduled orientations",
  },
  {
    name: "Add Interest Form",
    path: "/add-interest",
    icon: <FaIcons.FaNotesMedical className="home-icon" />,
    description: "Add a new student interest form",
  },
  {
    name: "Add Registration Form",
    path: "/add-registration",
    icon: <FaIcons.FaNotesMedical className="home-icon" />,
    description: "Add a new student registration form",
  },
  {
    name: "App Permissions",
    path: "/permissions",
    icon: <FaIcons.FaUserShield className="home-icon" />,
    description: "Update application permissions",
  },
   {
    name: "Email Logger",
    path: "/email-logs",
    icon: <FaIcons.FaClipboardList className="home-icon" />,
    description: "View Email Logger",
  },
];

const MenuItem = ({ item }) => {
  const { name, path, icon, description } = item;
  return (
    <Link to={path} className="menu-block-item">
      {icon}
      <h2>{name}</h2>
      <p>{description}</p>
    </Link>
  );
};

const HomePage = () => {
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const VERSION = import.meta.env.VITE_VERSION;

    useEffect(() => {
      const handleKeyPress = (event) => {
        // Check for Ctrl+Shift+V
        if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === "q") {
          toast.info(`🎮 Enrollments Dashboard Version: ${VERSION}`);
        }
      };
  
      window.addEventListener("keydown", handleKeyPress);
      return () => {
        window.removeEventListener("keydown", handleKeyPress);
      };
    }, []);

  const restrictedLinks = [
    "App Permissions",
    "Add Interest Form",
    "Add Registration Form",
  ];
  const topAuthorizedUsers = ["Super Admin", "Admin"];
  const middleAccessUsers = ["Super Admin", "Admin", "Contributor"];

  /*console.log(process.env); */

  return (
    <AdminLayout>
      <div className="admin-home">
        <div className="page-link-container">
          {pageLinks.map((item) => {
            return restrictedLinks.includes(item.name) ? (
              item.name === "App Permissions" ? (
                user && topAuthorizedUsers.includes(user.userStatus) ? (
                  <MenuItem item={item} />
                ) : null
              ) : user && middleAccessUsers.includes(user.userStatus) ? (
                <MenuItem item={item} />
              ) : null
            ) : (
              <MenuItem item={item} />
            );
          })}
        </div>
      </div>
    </AdminLayout>
  );
};

export default HomePage;
